import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Container, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    footer: {
        minHeight: '12rem',
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        textAlign: 'center',
        padding: '2rem',
    },
    nav: {
        '& ul': {
            margin: 'auto',
            display: 'inline-flex',
            flexWrap: 'wrap',
            listStyle: 'none',
            padding: 0,
            '& li': {
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                margin: '1rem',
                '& a': {
                    color: theme.palette.common.white,
                    textDecoration: 'none',
                    fontSize: '1.6rem',
                    '&:hover': {
                        textDecoration: 'underline',
                    },
                },
            },
        },
    },
    copyright: {
        fontSize: '1.6rem',
        marginTop: '1rem',
    },
}));

export default function Footer() {
    const classes = useStyles();

    return (
        <Box component="footer" className={classes.footer}>
            <Container>
                <Box component="nav" className={classes.nav}>
                    <ul>
                        <li><Link to="/help">ご利用方法</Link></li>
                        <li><Link to="/terms">利用規約</Link></li>
                        <li><Link to="/privacy">プライバシーポリシー</Link></li>
                        <li><Link to="/contact">お問い合わせ</Link></li>
                    </ul>
                </Box>
                <Typography className={classes.copyright}>
                    Copyright &copy; {new Date().getFullYear()} NZWorks
                </Typography>
            </Container>
        </Box>
    );
}
